export default __webpack_public_path__ + "static/media/Ellipse17.153c0a7b.png";